// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"400":"cb13d2da","453":"af196af9","455":"2a7d3eb4","644":"0d50e3bf","885":"c71b4d0e"}[chunkId] + ".chunk.js";
};